import React, { useState } from "react";
import { Transition } from "@headlessui/react";
import { useLocation } from "react-router-dom"; // For active link highlighting
import { FaMapMarkerAlt, FaClock, FaPhoneAlt } from "react-icons/fa";
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false); // State to manage the menu visibility
  const location = useLocation(); // Get current location to highlight active links

  // Toggle the mobile menu open/closed
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Navigation links array
  const navigationLinks = [
    { name: "HOME", path: "/" },
    { name: "ABOUT US", path: "/AboutUs" },
    { name: "CAREERS", path: "/Careers" },
    { name: "CONTACT US", path: "/ContactUs" },
  ];

  return (
    <nav className="bg-[#1E1A18] text-white shadow-md font-poppins mt-0 fixed top-0 left-0 w-full z-50 ">
      {/* Banner start */}
      <div className="flex bg-[#F5F0E5]  items-center px-4 text-xs">
        {/* Left Column */}
        <div className="flex-1  flex items-center space-x-6 ">
          <div className="flex items-center space-x-2 mt-2">
            <FaMapMarkerAlt className="text-gray-700" />
            <div>
              <p className=" text-gray-700">Vengamedu</p>
              <p className=" text-gray-700">Tirupur - 641603</p>
            </div>
          </div>
          <div className="hidden md:flex items-center space-x-2 mt-2">
            <FaClock className="text-gray-700" />
            <div>
              <p className=" text-gray-700">Open Hours:</p>
              <p className=" text-gray-700">09:00AM - 09:00PM IST</p>
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="flex-1 flex items-center justify-end">
          <div className="flex items-center space-x-2">
            <FaPhoneAlt className="text-gray-700" />
            <div>
              <p className=" text-gray-700">Phone Number:</p>
              <p className=" text-gray-700">+91 9445202342</p>
            </div>
          </div>
        </div>
      </div>
      {/* Banner end */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ">
        {/* Wrapper for the navbar, adds padding and max width */}

        {/* Large Screen Navbar (Desktop): Visible only on  larger screens */}
        <div className="hidden lg:flex justify-between items-center h-18">
          {/* Left Column (15%) */}
          <div className="w-[15%]"></div>

          {/* Middle Column (70%): Links and Logo */}
          <div className="w-[80%] flex justify-between items-center mx-[2%]">
            {/* Left Navigation Links */}
            <div className="flex space-x-10">
              <a
                href="/"
                className={`text-lg font-bold decoration-[#0000] hover:text-[#d5c0b9] hover:decoration-[#d5c0b9] transition duration-300 ${
                  location.pathname === "/ContactUs" ? " " : ""
                }`}
              >
                HOME
              </a>
              <a
                href="/AboutUs"
                className={`text-lg text-nowrap  font-bold decoration-[#0000] hover:text-[#d5c0b9] hover:decoration-[#d5c0b9] transition duration-300 ${
                  location.pathname === "/ContactUs" ? " " : ""
                }`}
              >
                ABOUT US
              </a>
            </div>

            {/* Logo in the Center */}
            <a href="/" className="mx-12">
              <img src="/MaduraNavLogo1.png" alt="Logo" className="h-16" />
            </a>

            {/* Right Navigation Links */}
            <div className="flex space-x-8">
              <a
                href="/Careers"
                className={`text-lg  font-bold decoration-[#0000] hover:text-[#d5c0b9] hover:decoration-[#d5c0b9] transition duration-300 ${
                  location.pathname === "/ContactUs" ? "  " : ""
                }`}
              >
                CAREERS
              </a>
              <a
                href="/ContactUs"
                className={`text-lg text-nowrap  font-bold decoration-[#0000] hover:text-[#d5c0b9] hover:decoration-[#d5c0b9] transition duration-300 ${
                  location.pathname === "/ContactUs" ? " " : ""
                }`}
              >
                CONTACT US
              </a>
            </div>
          </div>

          {/* Right Column (15%) */}
          <div className="w-[15%] ">
            <div className="flex justify-end">{/* Language change icon */}</div>
          </div>
        </div>

        {/* Small Screen Navbar (Mobile): Visible only on small screens */}
        <div className="lg:hidden flex justify-between items-center h-18">
          {/* Logo Centered */}
          <a href="/" className="mx-auto">
            <img src="/MaduraNavLogo.png" alt="Logo" className="h-16" />
          </a>

          {/* Hamburger Menu Button on the Right */}
          <div className="absolute right-4">
            {/* language change icon */}

            <button
              className="text-white focus:outline-none"
              onClick={toggleMenu}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                {/* Hamburger icon changes to "X" when menu is open */}
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"}
                ></path>
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu (Sliding from the right) */}
        <Transition
          show={isOpen} // Show/Hide the menu based on state
          enter="transition ease-out duration-300 transform"
          enterFrom="translate-x-full" // Start outside the viewport (to the right)
          enterTo="translate-x-0" // End at full visibility (in view)
          leave="transition ease-in duration-200 transform"
          leaveFrom="translate-x-0" // Start in view
          leaveTo="translate-x-full" // Slide out to the right
        >
          <div className="fixed top-0 right-0 w-[33.333%] h-full bg-[#1E1A18] text-white shadow-xl z-50 rounded-l-xl md:hidden">
            <div className="flex justify-end p-4">
              <button
                onClick={toggleMenu} // Close the menu
                className="text-white focus:outline-none"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {/* Close (X) button */}
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </button>
            </div>

            {/* Mobile Navigation Links */}
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 text-center">
              {navigationLinks.map((item) => (
                <a
                  key={item.name}
                  href={item.path}
                  className={`block   decoration-[#0000] hover:decoration-[#d5c0b9] hover:text-[#d5c0b9] active:decoration-[#d5c0b9] active:text-[#d5c0b9] px-3 py-2 rounded-md text-base font-medium transition duration-300 ${
                    location.pathname === item.path ? "" : ""
                  }`}
                  onClick={() => toggleMenu()} // Close menu on link click
                >
                  {item.name}
                </a>
              ))}
            </div>
          </div>
        </Transition>
      </div>
    </nav>
  );
};

export default Navbar;
